import { memo } from 'react';

import ButtonBase from '@mui/material/ButtonBase';
import Tooltip from '@mui/material/Tooltip';
import { Icon } from '@tecma/ds/icon';
import { useTranslation } from '@tecma/i18n';

import { useAppSelector } from '../redux/hooks';
import { sliceEnvironment } from '../redux/slice/slice.environment';

interface Props {
  titleLabel?: string;
  icon?: string;
  showTooltip?: boolean;
  stickToBottom?: boolean;
}

const SupportMenuButton = ({ titleLabel, icon, showTooltip, stickToBottom }: Props) => {
  const { t } = useTranslation();
  const environment = useAppSelector(sliceEnvironment.selectors.environment);
  const titleTranslated = t(`iTd.navbar.${titleLabel}`);
  const targetUrl = environment.REACT_APP_SUPPORT_BUTTON_TARGET_URL;

  return (
    <a className={`navbar-item ${stickToBottom ? 'bottom' : ''}`} href={targetUrl} target='_blank' rel='noopener noreferrer'>
      <Tooltip
        classes={{ tooltip: 'navbar-item-tooltip' }}
        disableFocusListener
        disableTouchListener
        disableHoverListener={!showTooltip}
        title={titleTranslated}
        placement='right'
      >
        <ButtonBase disableRipple>
          {icon && <Icon className='navbar-icon' iconName={icon} />}
          <div className='title'>{titleTranslated}</div>
        </ButtonBase>
      </Tooltip>
    </a>
  );
};

export default memo(SupportMenuButton);
